export default __webpack_public_path__ + "static/media/selfie.1c055f27.png";